import React, { memo } from "react";
import { ConfigProvider, Table } from "antd";
import ptBR from "antd/lib/locale/pt_BR";

import useServiceProtocols from "./useServiceProtocol";
import * as S from "./styles";
import BreadCrumbNavigation from "../../components/DataTable/TopSection/BreadCrumbNavigation";
import { columns } from "./constants";

const ServiceProtocols = () => {
  const {
    rowSelection,
    paginationConfig,
    loading,
    mappedServiceProtocol,
    handleTableChange,
  } = useServiceProtocols();

  return (
    <S.Container>
      <BreadCrumbNavigation
        preTableName="Configurações / Indicadores"
        tableName="Protocolos de Atendimento"
      />

      <S.TitleWrapper>
        <S.PageTitle>Protocolos de Atendimento</S.PageTitle>
        <S.Selection />
      </S.TitleWrapper>

      <S.Content>
        <ConfigProvider locale={ptBR}>
          <Table
            columns={columns}
            dataSource={mappedServiceProtocol}
            pagination={paginationConfig}
            loading={loading}
            onChange={handleTableChange}
            showSorterTooltip={false}
            style={{
              fontWeight: "bold",
            }}
          />
        </ConfigProvider>
      </S.Content>
    </S.Container>
  );
};

export default memo(ServiceProtocols);
